import useSWR, { type SWRConfiguration } from "swr";
import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import { config } from "@/config";
import type { CollarLogsGeoJsonResponse } from "./type";

async function getCollarLogsGeoJson(
  collarId: string,
): Promise<CollarLogsGeoJsonResponse> {
  const url = apiPaths.devices.collars.logs.getGeoJson(collarId);
  const response = await apiClient.get<CollarLogsGeoJsonResponse>(url);

  return response.data;
}

export function useGetCollarLogsGeoJson(
  collarId: string,
  options?: SWRConfiguration & { enabled?: boolean },
) {
  const enabled = options?.enabled ?? true;

  const mergedOptions: SWRConfiguration = {
    ...config.swr,
    ...options,
  };

  return useSWR(
    enabled ? ["fetch-collar-logs-geojson", collarId] : null,
    () => getCollarLogsGeoJson(collarId),
    mergedOptions,
  );
}
